var map = {
	"./(USDC:DAI).png": 546,
	"./(USDC:USDT).png": 547,
	"./BASE.png": 548,
	"./DAI.png": 549,
	"./DPI.png": 550,
	"./LONG.png": 551,
	"./MVI.png": 552,
	"./OLP(USDC:DAI).png": 553,
	"./PUNK.png": 554,
	"./STECRV-1.png": 555,
	"./STECRV.png": 556,
	"./STETH.png": 557,
	"./SUSHI.png": 558,
	"./UNI.png": 559,
	"./USDC.png": 560,
	"./USDN.png": 561,
	"./USDN3CRV-1.png": 562,
	"./USDN3CRV.png": 563,
	"./USDT.png": 564,
	"./WETH.png": 565,
	"./boba.png": 566,
	"./fantom.png": 567,
	"./poweredpolygon.png": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;